export const CONSENTS_TYPE = {
    Newsletter: 0,
    TermsAndConditions: 2,
    PrivacyPolicy: 3,
    Loyalty: 4,
    Personalisation: 5,
};

export enum ACTIVE_CONSENTS_TYPE {
    NEWSLETTER = "Newsletter",
    TERMS_AND_CONDITIONS = "TermsAndConditions",
    PRIVACY_POLICY = "PrivacyPolicy",
    LOYALTY = "Loyalty",
}
